import React from "react";
import SearchComponent from "./searchBar";
import FilterButton from "./filterButton";
import styled from "styled-components";
import ExportButton from "./exportButton";

export const FollowUpFilter = (props) => {
  const { exportButton } = props;

  return (
    <FilterRow exportButton={exportButton} className="mx-5">
      <LeftSection exportButton={exportButton}>
        <FilterButton
          context={props.context}
          showCallerName={props.showCallerName}
          showCallerUserNmber={props.showCallerUserNmber}
          showAgentName={props.showAgentName}
          showFollowupType={props.showFollowupType}
          showOrganization={props.showOrganization}
          showTitle={props.showTitle}
          showDateRange={props.showDateRange}
        />
        <SearchComponent context={props.context} />
      </LeftSection>

      {exportButton && (
        <RightSection>
          <ExportButton menuOptions={props.menuOptions} />
        </RightSection>
      )}
    </FilterRow>
  );
};
export default FollowUpFilter;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ exportButton }) =>
    exportButton ? "space-between" : "flex-end"};
  width: 95%;
`;

const LeftSection = styled.div`
  display: flex;
  gap: 0.5rem;

  ${({ exportButton }) =>
    !exportButton &&
    `
    justify-content: flex-end;
  `}
`;

const RightSection = styled.div`
  display: flex;
`;
